import React from "react";
import { RecoilRoot } from "recoil";

import { DetailPage } from '../uiParts/checkup_operation/DetailPage';

// 初期値のセット用
import { examOrderState } from '../store/examOrderState';
import { orderInfoState } from '../store/orderInfoState';
import { currentStatusState } from '../store/currentStatusState';

const OperationCheckup = (props) => {
  const { cm, user, staff_user, self_order, cource_pattern, clinics } = props;

  // 初期値のセット
  const initializeState = ({ set }) => {
    set(examOrderState, {
      id: self_order.id,
      status: self_order.status,
      examdt: self_order.examdt,
      examdtdate: self_order.examdtdate,
      examdtime: self_order.examdtime,
      examclinic_id: self_order.examclinic_id,
      examclinic: self_order.examclinic,
      examnote: self_order.examnote,
    });
    set(orderInfoState, self_order);
    const set_status = self_order ? self_order.status : '';
    set(currentStatusState, set_status)
  };

  return (
    <RecoilRoot initializeState={self_order && initializeState}>
      <DetailPage
        cm={cm}
        user={user}
        staff_user={staff_user}
        self_order={self_order}
        cource_pattern={cource_pattern}
        clinics={clinics}
      />
    </RecoilRoot>
  );
};

export default OperationCheckup;
